import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import types from "store/actions/types";

import * as S from "./style";

interface Props {
  placeHl: string;
  value?: string;
  onSearch?: (query: string) => void;
  inputId?: string;
}

const LEGACY_INPUT_ID = "searchInput";

const SearchLeftMenu = ({ placeHl, value, onSearch, inputId }: Props) => {
  const isUrlMode = onSearch != null;
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value ?? "");
  const resolvedInputId = isUrlMode
    ? inputId ?? "searchLeftMenuUrlInput"
    : LEGACY_INPUT_ID;

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  useEffect(() => {
    if (isUrlMode) {
      return;
    }
    dispatch({
      type: types.SEARCH_BAR,
      isOpen: false,
      searchValue: "",
    });
  }, [dispatch, isUrlMode]);

  const submitSearch = () => {
    const trimmed = inputValue.trim();
    if (isUrlMode) {
      onSearch!(trimmed);
      return;
    }
    const v: any = document.getElementById(LEGACY_INPUT_ID);
    dispatch({
      type: types.SEARCH_BAR,
      isOpen: false,
      searchValue: v?.value.trim() ?? "",
    });
  };

  return (
    <S.Content className="search-on-left-menu">
      <S.SearchInput
        id={resolvedInputId}
        placeholder={placeHl}
        onBlur={isUrlMode ? undefined : submitSearch}
        onKeyDown={(e: any) => {
          if (e?.keyCode === 13) submitSearch();
        }}
        {...(isUrlMode
          ? {
              value: inputValue,
              onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                setInputValue(e.target.value),
            }
          : {})}
        autoComplete="off"
      />
      <S.SearchButton
        type="text"
        icon={<span className="ti ti-search"></span>}
        onClick={submitSearch}
      />
    </S.Content>
  );
};

export default SearchLeftMenu;
